import './App.css';
// Componentes
import Header from '../Header/Header';
import Main from '../Main/Main';
import Logo from '../Logo/Logo';
import Cierre from '../Cierre/Cierre';

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Logo />
      <Cierre />
    </div>
  );
}

export default App;
